import { useState } from 'react';
import { api, usd } from '../lib/api';
import { ErrorNote, Modal, useLoad } from '../components/ui';

const TYPES: [string, string][] = [['asset', 'Assets (what you own)'], ['liability', 'Liabilities (what you owe)'], ['equity', 'Equity (the owner)'], ['income', 'Income'], ['expense', 'Expenses']];

// The chart of accounts: the list of categories every dollar in the books is filed under.
export default function AcctChart() {
  const chart = useLoad(() => api<any[]>('/api/accounting/chart-balances'), []);
  const [adding, setAdding] = useState(false);
  const [rename, setRename] = useState<any>(null);
  return (
    <div className="stack">
      <div className="row"><button className="primary" onClick={() => setAdding(true)}>Add an account</button><span className="faint">Most stores never need more than the standard list. Add one only when a report needs its own line.</span></div>
      <ErrorNote error={chart.error} />
      {TYPES.map(([type, label]) => (
        <div key={type} className="panel"><div className="panel-head"><h2>{label}</h2></div>
          <div className="table-wrap"><table className="grid"><tbody>
            {(chart.data ?? []).filter((a) => a.type === type).map((a) => (
              <tr key={a.code}><td style={{ width: 70 }}>{a.code}</td><td>{a.name}</td><td className="n">{a.balance_cents ? usd(a.balance_cents) : ''}</td><td style={{ width: 90 }}><button className="ghost" onClick={() => setRename(a)}>Rename</button></td></tr>))}
          </tbody></table></div></div>))}
      {adding && <AddAccount onClose={() => setAdding(false)} onDone={() => { setAdding(false); chart.reload(); }} />}
      {rename && <Rename a={rename} onClose={() => setRename(null)} onDone={() => { setRename(null); chart.reload(); }} />}
    </div>
  );
}

function AddAccount({ onClose, onDone }: { onClose: () => void; onDone: () => void }) {
  const [f, setF] = useState({ name: '', type: 'expense' });
  const [err, setErr] = useState<unknown>(null);
  return (
    <Modal title="Add an account" onClose={onClose} footer={<button className="primary" disabled={f.name.trim().length < 2} onClick={async () => { try { await api('/api/accounting/chart', { body: f }); onDone(); } catch (e) { setErr(e); } }}>Add</button>}>
      <ErrorNote error={err} />
      <label>Name<input autoFocus value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} placeholder="e.g. Trash pickup" /></label>
      <label>Kind<select value={f.type} onChange={(e) => setF({ ...f, type: e.target.value })}>{TYPES.map(([k, l]) => <option key={k} value={k}>{l}</option>)}</select></label>
      <p className="faint">An expense account shows up in the Expenses category list and on the profit and loss. The number is picked for you.</p>
    </Modal>
  );
}

function Rename({ a, onClose, onDone }: { a: any; onClose: () => void; onDone: () => void }) {
  const [name, setName] = useState(a.name);
  const [err, setErr] = useState<unknown>(null);
  return (
    <Modal title={`Rename ${a.code}`} onClose={onClose} footer={<button className="primary" disabled={name.trim().length < 2} onClick={async () => { try { await api(`/api/accounting/chart/${a.code}`, { method: 'PUT', body: { name } }); onDone(); } catch (e) { setErr(e); } }}>Save</button>}>
      <ErrorNote error={err} /><label>Name<input autoFocus value={name} onChange={(e) => setName(e.target.value)} /></label>
    </Modal>
  );
}
